import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinStateEditSource',
  props: {
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit, create, or readonly?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    twinType: {
      type: String,
      required: false,
      default: null
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    dataSources: {
      type: Array,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    otherStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    stateDefinition: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      numberRule: [function (v) {
        return !!v && /^([0-9]+)\.?([0-9]*)$/.exec(v) !== null || parseFloat(v) === 0 || _this.$i18n_t('DigitalTwin.DigitalTwin.states.randomMustBeNumber');
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    matchDataSource: function matchDataSource(type) {
      return this.dataSources.find(function (d) {
        return d.type === type;
      }) || {};
    }
  }
};